import { render, staticRenderFns } from "./FinancialExtract.vue?vue&type=template&id=36f54012"
import script from "./FinancialExtract.vue?vue&type=script&lang=js"
export * from "./FinancialExtract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36f54012')) {
      api.createRecord('36f54012', component.options)
    } else {
      api.reload('36f54012', component.options)
    }
    module.hot.accept("./FinancialExtract.vue?vue&type=template&id=36f54012", function () {
      api.rerender('36f54012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/teacher/FinancialExtract.vue"
export default component.exports